
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/[uid]",
      function () {
        return require("private-next-pages/project/[uid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/[uid]"])
      });
    }
  